<template>
  <div>
    <md-card class="card-container">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <h1>Neo-Psy CRM</h1>
        <!-- <page&#45;title :title="isEditing ? '修改標籤類別' : '新增標籤類別'"></page&#45;title> -->
      </div>
    </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field>
            <label>帳號</label>
            <md-input v-model="username"></md-input>
          </md-field>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <div class="md-layout-item">
            <md-field>
              <label>密碼</label>
              <md-input v-model="password" type="password"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <div class="md-layout-item">
            <md-button class="md-raised md-primary" @click="login">登入</md-button>
          </div>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
// import authService from '@/services/auth'
import { mapActions, mapMutations } from 'vuex'

export default {
  data () {
    return {
      username: null,
      password: null
    }
  },
  methods: {
    ...mapActions('auth', {
      submitLogin: 'SUBMIT_LOGIN'
    }),
    ...mapMutations('nav', {
      showNav: 'show'
    }),
    async login () {
      let username = this.username
      let password = this.password
      if (await this.submitLogin({username, password})) {
        this.showNav()
        this.$router.push('/patient')
      } else {
        console.log('error')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue